import { render, staticRenderFns } from "./CheckResourceList.vue?vue&type=template&id=a2473a20&"
import script from "./CheckResourceList.vue?vue&type=script&lang=js&"
export * from "./CheckResourceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports